import React from 'react';

const UpArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.479 31.479">
      <path
        fill="#fff"
        d="M26.477 10.274c.444.444.444 1.143 0 1.587-.429.429-1.143.429-1.571 0l-8.047-8.047v26.555c0 .619-.492 1.111-1.111 1.111s-1.127-.492-1.127-1.111V3.813L6.59 11.86c-.444.429-1.159.429-1.587 0-.444-.444-.444-1.143 0-1.587L14.955.321c.429-.429 1.143-.429 1.571 0l9.951 9.953z"
      />
    </svg>
  );
};

export default UpArrow;
